import { IResearchedAd } from '@/api/research-jobs/ads/get-researched-ads-query'

/**
 * The competitor-ad composer attachment for a researched ad — shared by the single-ad "Create this
 * ad for me" action and the bulk attach-to-chat selection action.
 */
export function buildResearchAdAttachment(ad: IResearchedAd) {
    const title = ad.creative.title || ad.brand?.name || 'Ad Creative'
    const description = [ad.creative.caption, ad.creative.body, ad.creative.description]
        .filter(Boolean)
        .join(' ')
        .slice(0, 500)

    const thumbnailUrl =
        ad.creative.thumbnailFile?.videoThumbnailUrl ??
        ad.creative.thumbnailFile?.url ??
        ad.creative.mediaFile?.videoThumbnailUrl ??
        ad.creative.mediaFile?.url

    return {
        type: 'competitor-ad' as const,
        uuid: ad.uuid,
        title,
        description: description || title,
        thumbnailFileUuid: ad.creative.thumbnailFile?.uuid ?? ad.creative.mediaFile?.uuid ?? undefined,
        thumbnailUrl,
    }
}
